module.exports = __webpack_public_path__ + "static/media/Q3_Front_Left.1f28609e.png";